import { render, staticRenderFns } from "./LoadOrderTable.vue?vue&type=template&id=0dcf2c35&scoped=true"
import script from "./LoadOrderTable.vue?vue&type=script&lang=ts"
export * from "./LoadOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./LoadOrderTable.vue?vue&type=style&index=0&id=0dcf2c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf2c35",
  null
  
)

export default component.exports